export function defaultAiChatSettings(): ChatSettingsModel
{
    return {
        enableAiChat: false,
        azureResourceUri: null,
        chatDeploymentName: null,
        embeddingDeploymentName: null,
        azureOpenAIKey: null,
        outlineApiKey: null,
        outlineMainDocumentId: null,
        langfusePublicKey: null,
        langfuseSecretKey: null
    };
}
